<template>
    <div class="page-wrapper" v-if="$route.name!=='Set Password' && $route.name!=='Reset Password' && $route.name !=='Vendor Agreement Sign'">
        <div class="">
            <Header v-if="userdata != null && userdata !='' && $route.name !== 'login'" />
        </div>
        <div class="page-body-wrapper">
            <Sidebar v-if="userdata != null && userdata !='' && $route.name !== 'login'" class="page-sidebar" />
            <div class="page-body">
                <router-view />
            </div>
            <Footer v-if="userdata != null && userdata !='' && $route.name !== 'login'" />
            <!-- END PAGE CONTENT -->
        </div>
        <!-- END MAIN CONTENT -->
    </div>
    <div class="page-wrapper" v-if="$route.name=='Set Password' || $route.name=='Reset Password' || $route.name=='Vendor Agreement Sign'">
        <div class="page-body">
            <router-view />
        </div>
    </div>
</template>

<script>
    import Header from "@/layouts/header/Header.vue"
    import Sidebar from '@/layouts/sidebar/Sidebar.vue';
    import Footer from "@/layouts/footer/footer.vue";
    //import minJs from "@/assets/CustomJs/jquery-3.4.1.min.js"
    //import boostrp from "@/assets/CustomJs/bootstrap.min.js"
    //import customjs from "@/assets/CustomJs/front.js"

    export default {
        name: 'LayoutName',
        components: {
            Header,
            Sidebar, Footer
        },
        created() {
            
            //alert(this.$route.name);
            this.userdata = localStorage.getItem("access_token");
            //var scripts = [
            //    "https://portal.orbistream.com/assets/js/front.js"

            //];
            //scripts.forEach(script => {
            //    let tag = document.createElement("script");
            //    tag.setAttribute("src", script);
            //    document.head.appendChild(tag);

            //});
        },
        mounted() {
            //this.userdata = localStorage.getItem("access_token");
            //var scripts = [
            //   './assets/js/front.js'
            //];
            //scripts.forEach(script => {
            //    let tag = document.createElement("script");
            //    tag.setAttribute("src", script);
            //    document.head.appendChild(tag);
            //});
        }
        ,
        data() {

            return {
                userdata: null
            };
        },

    }
</script>